export const mockIndustryList = [
  {
    industryCategoryId: 1, // 行业分类ID
    industryCategoryName: 'test1', // 行业分类名称
  },
  {
    industryCategoryId: 2, // 行业分类ID
    industryCategoryName: 'test2', // 行业分类名称
  },
];

export const mockTalkList = [
  {
    industryCategoryId: 1,
    callTalkId: 1, // 话术ID
    callTalkName: 'talk1', // 话术名称
    sampleAudioUrl: 'https://maibao.pic.qq.com/a5202e55-e4b6-4f3e-9dd3-a84aa5d4c961', // 示例音频URL
    variables: [
      // 话术变量
      {
        name: 'talk_key1', // 英文名称
        cname: '中文名字1', // 中文名称
      },
      {
        name: 'talk_key3', // 英文名称
        cname: '中文名字3', // 中文名称
      },
    ],
  },
  {
    industryCategoryId: 2,
    callTalkId: 2, // 话术ID
    callTalkName: 'talk2', // 话术名称
    sampleAudioUrl: 'http://autocalltalksample-75888.gzc.vod.tencent-cloud.com/dXlffVvuvm.mp3', // 示例音频URL
    variables: [
      // 话术变量
      {
        name: 'talk_key2', // 英文名称
        cname: '中文名字2', // 中文名称
      },
      {
        name: 'talk_key4', // 英文名称
        cname: '中文名字4', // 中文名称
      },
    ],
  },
];

export const mockRuleList = [
  {
    id: 1,
    name: '规则1',
    industryCategoryId: 1, // 行业分类ID
    callTalkId: 1, // 话术ID
    variables: [
      // 话术变量取值列表
      {
        name: 'talk_key1', // 英文名称
        value: '123', // 变量值
      },
      {
        name: 'talk_key3', // 英文名称
        value: '123', // 变量值
      },
    ],
    applyRange: {
      // 适用范围
      dimension: 1, // 维度名称：1-推广计划，2-广告，3-落地页
      values: ['1', '2', '3'], // 纬度值
    },
    enabled: true, // 是否启用
    status: 0,
  },
  {
    id: 2,
    name: '规则1',
    industryCategoryId: 2, // 行业分类ID
    callTalkId: 2, // 话术ID
    variables: [
      // 话术变量取值列表
      {
        name: 'talk_key2', // 英文名称
        value: '123', // 变量值
      },
      {
        name: 'talk_key4', // 英文名称
        value: '123', // 变量值
      },
    ],
    applyRange: {
      // 适用范围
      dimension: 2, // 维度名称：1-推广计划，2-广告，3-落地页
      values: ['1', '2', '3'], // 纬度值
    },
    enabled: false, // 是否启用
    status: 0,
  },
];

export const OPERATION = {
  NEW: 1,
  EDIT: 2,
  DELETE: 3,
};
